import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { viewerDisabledProps, isViewer } from "../utils/permissions";
const AddKitchen = ({ onKitchenAdded }) => {
  const [kitchen_name, setKitchen_name] = useState("");
  const [address, setAddress] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleAdd = async (e) => {
    
    e.preventDefault();
    setLoading(true);
    const userid = localStorage.getItem("user_id");
    console.log("User ID:", userid);

    const body = {
      kitchen_name,
      kitchen_address: address,
      user_name: username,
      password,
      added_by: 1,
    };
    try {
      const response = await axios.post(
        "https://ims-attendanceback.indevconsultancy.in/api/kitchen",
        body
      );
      alert("Kitchen added successfully!");
      navigate("/kitchenlist");
      if (onKitchenAdded) {
        onKitchenAdded(response.data);
      }
      handleReset();
    } catch (error) {
      console.error(error);
      alert("Error adding kitchen. Check console for details.");
    } finally {
      setLoading(false);
    }
  };
  
  const handleReset = () => {
    setKitchen_name("");
    setAddress("");
    setUsername("");
    setPassword("");
  };
  
  return (
    <div className="bg-cream min-vh-100 py-2">
      <div className="container my-4">
        <div className="card shadow-lg">
          <div className="card-header bg-skyBlue text-white">
            <h5 className="mb-0">Add Kitchen</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleAdd}>
              <div className="mb-3">
                <label>Kitchen Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={kitchen_name}
                  onChange={(e) => setKitchen_name(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label>Address</label>
                <input
                  type="text"
                  className="form-control"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label>User Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label>Password</label>
                <input
                  type="text"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || isViewer()}
                  {...(isViewer() ? viewerDisabledProps() : {})}
                >
                  {loading ? "Saving..." : "Save Kitchen"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default AddKitchen;
